import Papa from "papaparse";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { formatDateTime, formatUSD } from "@/lib/api";

const HEADERS = ["Date & Time", "Customer", "Driver", "Vehicle", "Pickup", "Drop-off", "Reason", "Miles", "Fee (USD)", "Payment Status", "Status", "Source"];
const SOURCE = { customer_request: "Customer", staff_entry: "Staff", csv_import: "Import" };

const toRow = (j) => [
  formatDateTime(j.date_time), j.customer_name, j.driver_name, j.vehicle_info, j.pickup_location, j.dropoff_location,
  j.reason_for_tow, j.distance_miles != null ? j.distance_miles.toFixed(1) : "", Number(j.towing_fee).toFixed(2),
  j.payment_status, j.status, SOURCE[j.source],
];

const stamp = () => new Date().toISOString().slice(0, 10);
const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

const download = (blob, name) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
};

export function exportCSV(jobs, company) {
  const csv = Papa.unparse({ fields: HEADERS, data: jobs.map(toRow) });
  download(new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" }), `${slug(company)}-jobs-${stamp()}.csv`);
}

export function downloadImportTemplate() {
  const csv = Papa.unparse({
    fields: ["date_time", "customer_name", "driver_name", "vehicle_make", "vehicle_model", "pickup_location", "dropoff_location", "reason_for_tow", "distance_miles", "towing_fee", "payment_status", "status"],
    data: [["2026-01-15 14:30", "Jane Doe", "Sam Driver", "Honda", "Civic", "100 Oak St", "200 Pine Ave", "Breakdown", "12", "148.00", "Paid", "Completed"]],
  });
  download(new Blob([csv], { type: "text/csv;charset=utf-8;" }), "job-import-template.csv");
}

export function exportPDF(jobs, company) {
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "letter" });
  const w = doc.internal.pageSize.getWidth();
  const sum = (list) => list.reduce((s, j) => s + Number(j.towing_fee || 0), 0);
  const billable = jobs.filter((j) => j.status !== "Cancelled");
  const byPay = (st) => sum(billable.filter((j) => j.payment_status === st));

  doc.setFillColor(3, 7, 18);
  doc.rect(0, 0, w, 64, "F");
  doc.setFillColor(0, 245, 255);
  doc.rect(0, 64, w, 3, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text(`${company} — Job Records`, 36, 40);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(`Generated ${new Date().toLocaleString("en-US")}  ·  ${jobs.length} jobs`, w - 36, 40, { align: "right" });

  autoTable(doc, {
    startY: 88,
    head: [HEADERS],
    body: jobs.map((j) => { const r = toRow(j); r[8] = formatUSD(j.towing_fee); return r; }),
    foot: [["", "", "", "", "", "", "", "Billable total", formatUSD(sum(billable)), "", "", ""]],
    theme: "grid",
    styles: { fontSize: 7, cellPadding: 3.5, lineColor: [226, 232, 240], textColor: [30, 41, 59] },
    headStyles: { fillColor: [241, 245, 249], textColor: [15, 23, 42], fontStyle: "bold" },
    footStyles: { fillColor: [236, 254, 255], textColor: [15, 23, 42], fontStyle: "bold" },
    alternateRowStyles: { fillColor: [248, 250, 252] },
    columnStyles: { 7: { halign: "right" }, 8: { halign: "right" } },
    margin: { left: 30, right: 30 },
    didDrawPage: () => {
      doc.setFontSize(8);
      doc.setTextColor(100, 116, 139);
      doc.text(`Page ${doc.getNumberOfPages()}`, w - 30, doc.internal.pageSize.getHeight() - 18, { align: "right" });
    },
  });

  doc.setFontSize(9);
  doc.setTextColor(15, 23, 42);
  doc.text(
    `Paid: ${formatUSD(byPay("Paid"))}   ·   Pending: ${formatUSD(byPay("Pending"))}   ·   Unpaid: ${formatUSD(byPay("Unpaid"))}   ·   Billable total (excl. cancelled): ${formatUSD(sum(billable))}`,
    30, doc.lastAutoTable.finalY + 22
  );
  doc.save(`${slug(company)}-jobs-${stamp()}.pdf`);
}
